import AddressComponent from '../cells/text/address';
import {Address} from '../../models/address';
import styles from './orderAddress.module.css';
import OrderAddressLoader from './orderAddressLoader';
import {Typography} from '@toppy-webshop/toppy-design-system';
import React from 'react';
import {useI18nContext} from '../../i18n/i18n-react';

interface Props {
    address?: Address;
}

const OrderAddress = ({address}: Props) => {
    const {LL} = useI18nContext();

    return (
        <>
            <Typography variant={'h6'}>
                {LL.order.shippingAddress.title()}
            </Typography>
            <div className={styles.container}>
                {!address && <OrderAddressLoader />}
                {address && (
                    <AddressComponent
                        name={address.firstname + ' ' + address.lastname}
                        address={(
                            address.street +
                            ' ' +
                            address.houseNumber +
                            ' ' +
                            address.addition
                        ).trim()}
                        postcode={address.postcode}
                        city={address.city}
                        country_id={address.country_id}
                        telephone={address.telephone}
                    />
                )}
                <img
                    className={styles.image}
                    alt="Huis pictogram"
                    src={
                        'https://cdn.toppy-dev.nl/frontend/Toppy/base-v2/nl_NL/images/icons/location_customer.40672945.png'
                    }
                />
            </div>
        </>
    );
};

export default OrderAddress;
